import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Modal from "../../modal/Modal";
import { alertError, alertInfo, toastInfo } from "actions/ui";
import { sendUserCommand, clearUserCommand } from "actions/commands";
import { focusChannel, openChannel } from "actions/ui";
import { addChannel } from "actions/application";

class ChannelAdd extends React.Component {

	constructor(props, context) {
		super(props, context);

		this.state = {
			modalOpen: false,
			...this.getCleanState()
		}

		this.handleAdd = this.handleAdd.bind(this);
		this.openModal = this.openModal.bind(this);
	}

	getCleanState() {
		return {
			name: '',
			type: undefined,
			invalidName: false,
			invalidType: false
		}
	}

	handleAdd() {
		if (this.validate()) {
			this.props.sendUserCommand('createChannel', 'createChannel', { name: this.state.name, type: this.state.type });
		}
	}

	validate() {
		let valid = true;

		if (!this.state.name) {
			this.setState( state => ({ invalidName: true }) );
			valid = false;
		}
		if (!this.state.type) {
			this.setState( state => ({ invalidType: true }) );
			valid = false;
		}

		return valid;
	}

	openModal(e) {
		e.preventDefault();
		this.setState({ modalOpen: true, ...this.getCleanState() });
	}

	componentDidUpdate(prevProps) {
		const commandFailure = this.props.command !== prevProps.command && this.props.command && this.props.command.success === false;
		const commandSuccess = this.props.command !== prevProps.command && this.props.command && this.props.command.success === true;

		if (commandFailure) {
			this.props.alertError(this.props.command.error);
			this.props.clearUserCommand('createChannel');
		}

		if (commandSuccess) {
			this.setState({ modalOpen: false });
			this.props.clearUserCommand('createChannel');

			const channel = this.props.command.result.channel;

			this.props.addChannel(channel);
			this.props.openChannel(channel.id, true);
			this.props.focusChannel(channel.id);
			this.props.toastInfo(this.props.i18n.channelCreated);
		}
	}

	render() {
		if (!this.props.userRights.createChannels) {
			return null;
		}

		return <React.Fragment>
			<a href="#" className={ "wcFunctional " + this.props.className } title={ this.props.i18n.createChannel } onClick={ this.openModal }><span className="wcIcon wcIconPlus" />{ this.props.label ? this.props.i18n.createChannel : '' }</a>
			<Modal
				open={ this.state.modalOpen }
				onClose={ e => this.setState({ modalOpen: false }) }
				title={ this.props.i18n.createChannel }
				footer={ [
					<button key="create" className="wcButton" onClick={ this.handleAdd } disabled={ this.props.command && this.props.command.inProgress }>{ this.props.i18n.createChannel }</button>
				] }
				closable={ !(this.props.command && this.props.command.inProgress) }
				closeOnDocumentClick={ false }
			>
				<div className="wcFormRow">
					<label>{ this.props.i18n.name }: </label>
					<input
						className={ `wcFormControl ${ this.state.invalidName ? ' wcFormError' : ''}` }
						type="text"
						maxLength={ 200 }
						value={ this.state.name }
						onChange={ e => this.setState({ name: e.target.value, invalidName: false })}
					/>
					<div className="wcFormErrorMessage">{ this.props.i18n.enterChannelName }</div>
				</div>

				<div className="wcFormRow">
					<input
						className={ `wcFormCheck ${ this.state.invalidType ? ' wcFormError' : ''}` }
						type="radio"
						checked={ this.state.type === 'private' }
						value="private"
						onChange={ e => this.setState({ type: e.target.value, invalidType: false })}
						name="flexRadioDefault"
						id="type1"
					/>
					<label className="wcFormCheckLabel" htmlFor="type1">
						{ this.props.i18n.privateChannel }
					</label>
					<input
						className={ `wcFormCheck ${ this.state.invalidType ? ' wcFormError' : ''}` }
						type="radio"
						checked={ this.state.type === 'public' }
						value="public"
						onChange={ e => this.setState({ type: e.target.value, invalidType: false })}
						name="flexRadioDefault"
						id="type2"
					/>
					<label className="wcFormCheckLabel" htmlFor="type2">
						{ this.props.i18n.publicChannel }
					</label>
					<div className="wcFormErrorMessage">{ this.props.i18n.selectChannelType }</div>
				</div>
				{ this.state.type &&
					<div className="wcFormRow">
						{ this.state.type === 'public' && this.props.i18n.hintPublic }
						{ this.state.type === 'private' && this.props.i18n.hintPrivate }
					</div>
				}

			</Modal>
		</React.Fragment>
	}

}

ChannelAdd.propTypes = {
	configuration: PropTypes.object.isRequired,
	label: PropTypes.bool,
	className: PropTypes.string
};

export default connect(
	(state) => ({
		userRights: state.application.user.rights,
		configuration: state.configuration,
		i18nBase: state.configuration.i18n,
		i18n: state.application.i18n,
		command: state.commands.sent.createChannel
	}),
	{ sendUserCommand, clearUserCommand, alertError, alertInfo, focusChannel, openChannel, addChannel, toastInfo }
)(ChannelAdd);